export default __webpack_public_path__ + "static/media/twitter.de4886ac.svg";